module.exports = __webpack_public_path__ + "assets/img/hadeTitle@2x.e683afbb.png";